import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import Carousel from './Carousel';
import Item from './Item';
import { getUpcomingEvents } from '../api/api';

const styles = theme => ({
  root: {
    margin: '30px 0px'
  },
  noItems: {
    padding: 50,
    textAlign: 'center'
  },
  loading: {
    display: 'flex',
    justifyContent: 'center',
    padding: '50px 0'
  }
});

class FutureEvents extends Component {
  state = {
    open: false,
    selected: 0,
    events: [],
    loading: true
  }

  async componentDidMount() {
    try {
      const response = await getUpcomingEvents();
      const events = response.items.map(item => ({
        id: item.id,
        image: item.imageUrl,
        description: item.description,
        caption: item.description
      }));
      this.setState({ events, loading: false });
    } catch (err) {
      console.error('Failed to load upcoming events:', err);
      this.setState({ loading: false });
    }
  }

  expand = id => {
    const { events } = this.state;
    const index = events.findIndex(photo => photo.id === id);
    this.setState({ selected: index, open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleChange = selected => {
    this.setState({ selected });
  };

  render() {
    const { classes } = this.props;
    const { open, selected, events, loading } = this.state;

    if (loading) {
      return (
        <div className={classes.loading}>
          <CircularProgress />
        </div>
      );
    }

    return (
      <div className={classes.root}>
        {events.length < 1 ? (
          <Grid item xs={12}>
            <div align="center" className={classes.noItems}>
              <Typography align="center" variant="h5">
                There are no events scheduled currently
              </Typography>
            </div>
          </Grid>
        ) : (
          <Grid container spacing={2} direction="row" alignItems="flex-start">
            {events.map(event => (
              <Item
                key={event.id}
                section={event}
                width={4}
                expendable
                type="photo"
                onExpand={this.expand}
              />
            ))}
          </Grid>
        )}

        {events.length > 0 && (
          <Carousel
            items={events}
            open={open}
            selected={selected}
            onClose={this.handleClose}
            onChange={this.handleChange}
          />
        )}
      </div>
    );
  }
}

FutureEvents.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(FutureEvents);
